import { createFileRoute } from "@tanstack/react-router";
import { DeptContentList } from "@/components/dept-content/DeptContentList";
import { COE_UPDATES } from "@/lib/deptContent";

export const Route = createFileRoute("/_app/coe/updates/")({
  component: () => <DeptContentList cfg={COE_UPDATES} />,
});
